import { render, staticRenderFns } from "./interviewProcess.vue?vue&type=template&id=5af9680e&scoped=true"
import script from "./interviewProcess.vue?vue&type=script&lang=js"
export * from "./interviewProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af9680e",
  null
  
)

export default component.exports